<template>
  <li
    :class="{
      [styles.air__menuLeft__item]: true,
      [styles.air__menuLeft__item__active]: item.key === activeItem,
      [`${theme}-menu-active`]: item.key === activeItem,
    }"
  >
    <router-link v-if="!item.isExternal" :to="redirectUrl" :class="styles.air__menuLeft__link">
      <i
        v-if="item.icon"
        :class="{
          [item.icon]: true,
          [styles.air__menuLeft__icon]: true,
        }"
      />
      <span>{{ item.title }}</span>
      <span
        style="background-color: red; width: 20px; height: 18px; color: white; font-size: 14px; border-radius: 10px; display: inline-block; text-align: center; line-height: 1.2rem; margin-left: 5px"
        v-if="item.badge_number"
        >{{ item.badge_number }}</span
      >
      <span v-if="item.badge" :title="item.badge.hover">
        <i
          :class="{
            [item.badge.icon]: true,
            'menu-badge': true,
          }"
        />
      </span>
    </router-link>
    <a v-else :href="item.url" target="_blank" rel="noopener noreferrer" :class="styles.air__menuLeft__link">
      <i
        v-if="item.icon"
        :class="{
          [item.icon]: true,
          [styles.air__menuLeft__icon]: true,
        }"
      />
      <span>{{ item.title }}</span>
    </a>
  </li>
</template>

<script>
export default {
  name: 'Item',
  props: {
    theme: String,
    item: Object,
    styles: Object,
    activeItem: String,
  },
  computed: {
    redirectUrl() {
      const locale = this.$store.state.settings.locale;
      if (locale === 'es') {
        return `/${locale}${this.item.url}`;
      }
      return this.item.url;
    },
  },
};
</script>
